// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_f","play":"ag"};